class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() === 'SPACE'
        ) {
          event.preventDefault();
          this.open(cartLink);
        }
      }
    );
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    setTimeout(() => {
      this.classList.add(
        'animate',
        'active'
      );
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector(
                '.drawer__inner-empty'
              )
            : document.getElementById(
                'CartDrawer'
              );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        if (
          containerToTrapFocusOn &&
          focusElement
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      { once: true }
    );

    document.body.classList.add(
      'overflow-hidden'
    );
  }

  close() {
    this.classList.remove('active');

    removeTrapFocus(
      this.activeElement
    );

    document.body.classList.remove(
      'overflow-hidden'
    );
  }

  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute(
        'id'
      )
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote
          .nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    const drawerInner =
      this.querySelector(
        '.drawer__inner'
      );

    if (
      drawerInner &&
      drawerInner.classList.contains(
        'is-empty'
      )
    ) {
      drawerInner.classList.remove(
        'is-empty'
      );
    }

    this.classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach(
      (section) => {
        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        const sectionHTML =
          parsedState.sections?.[
            section.id
          ];

        if (
          !sectionElement ||
          !sectionHTML
        ) {
          return;
        }

        const newHTML =
          this.getSectionInnerHTML(
            sectionHTML,
            section.selector
          );

        if (newHTML !== null) {
          sectionElement.innerHTML =
            newHTML;
        }
      }
    );

    /*
     * IMPORTANTE
     *
     * Shopify ya renderizó el drawer,
     * pero comprobamos de nuevo el
     * item_count real para garantizar
     * el primer add desde carrito vacío.
     */
    this.refreshCartCount();

    setTimeout(() => {
      const overlay =
        this.querySelector(
          '#CartDrawer-Overlay'
        );

      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      this.open();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    const documentHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const element =
      documentHTML.querySelector(
        selector
      );

    if (!element) {
      return null;
    }

    return element.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(selector);
  }

  /*
   * =====================================================
   * TECHNO EXPRESS
   * FORZAR ACTUALIZACIÓN DEL BADGE
   * =====================================================
   */

  async refreshCartCount() {
    try {
      const root =
        window.Shopify?.routes?.root ||
        '/';

      const response =
        await fetch(
          `${root}cart.js`,
          {
            method: 'GET',

            headers: {
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },

            credentials:
              'same-origin',

            cache: 'no-store'
          }
        );

      if (!response.ok) return;

      const cart =
        await response.json();

      this.updateCartCountBubble(
        cart.item_count
      );
    } catch (error) {
      console.warn(
        '[Techno Cart] Cart count could not be updated.',
        error
      );
    }
  }

  updateCartCountBubble(
    itemCount
  ) {
    const count = Math.max(
      0,
      Number(itemCount) || 0
    );

    const cartLink =
      document.querySelector(
        '#cart-icon-bubble'
      );

    if (!cartLink) return;

    let bubble =
      cartLink.querySelector(
        '.cart-count-bubble'
      );

    /*
     * Fallback:
     *
     * Si por alguna razón el Liquid
     * todavía no creó el bubble,
     * lo creamos vía JS.
     */
    if (!bubble) {
      bubble =
        document.createElement(
          'div'
        );

      bubble.className =
        'cart-count-bubble';

      bubble.setAttribute(
        'data-cart-count-bubble',
        ''
      );

      const number =
        document.createElement(
          'span'
        );

      number.setAttribute(
        'aria-hidden',
        'true'
      );

      number.setAttribute(
        'data-cart-count',
        ''
      );

      bubble.appendChild(number);

      cartLink.appendChild(
        bubble
      );
    }

    let number =
      bubble.querySelector(
        '[data-cart-count]'
      );

    if (!number) {
      number =
        bubble.querySelector(
          'span[aria-hidden="true"]'
        );
    }

    if (!number) {
      number =
        document.createElement(
          'span'
        );

      number.setAttribute(
        'aria-hidden',
        'true'
      );

      number.setAttribute(
        'data-cart-count',
        ''
      );

      bubble.prepend(number);
    }

    /*
     * Actualizar número
     */
    if (count < 100) {
      number.textContent =
        count;
    } else {
      number.textContent =
        '99+';
    }

    /*
     * Mostrar / ocultar
     */
    if (count > 0) {
      bubble.classList.remove(
        'hidden'
      );

      bubble.hidden = false;

      bubble.setAttribute(
        'aria-hidden',
        'false'
      );
    } else {
      bubble.classList.add(
        'hidden'
      );

      bubble.hidden = true;

      bubble.setAttribute(
        'aria-hidden',
        'true'
      );
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section:
          'cart-drawer',
        selector:
          '.drawer__inner'
      },
      {
        id:
          'cart-icon-bubble',
        section:
          'cart-icon-bubble',
        selector:
          '.shopify-section'
      }
    ];
  }
}

if (
  !customElements.get(
    'cart-drawer-items'
  )
) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}